import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/solid';

export default function MarketingCtaBand({
  heading,
  body,
  primaryTo = '/signup',
  primaryLabel = 'Become a member',
  secondaryTo = '/contact',
  secondaryLabel = 'Contact us',
}) {
  return (
    <section className="relative overflow-hidden py-24 sm:py-28 bg-grain">
      <img
        src="/images/community.webp"
        alt=""
        className="absolute inset-0 h-full w-full object-cover"
        aria-hidden
      />
      <div className="absolute inset-0 bg-gradient-to-br from-oak-950/92 via-claire-900/88 to-oak-900/90" />
      <div className="pointer-events-none absolute -right-20 top-10 h-64 w-64 rounded-full bg-claire-400/25 blur-3xl animate-pulse-soft" />
      <div className="pointer-events-none absolute -left-16 bottom-0 h-56 w-56 rounded-full bg-oak-300/20 blur-3xl" />

      <div className="relative mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
        <div className="mx-auto mb-6 h-px w-16 bg-gradient-to-r from-transparent via-claire-300 to-transparent" />
        <h2 className="font-display text-3xl font-semibold text-white sm:text-4xl lg:text-5xl">{heading}</h2>
        {body ? <p className="mt-5 text-lg leading-relaxed text-claire-100/95 sm:text-xl">{body}</p> : null}
        <div className="mt-10 flex flex-col justify-center gap-3 sm:flex-row sm:gap-4">
          <Link
            to={primaryTo}
            className="inline-flex items-center justify-center bg-white px-8 py-3.5 text-base font-semibold text-oak-900 shadow-lg transition hover:-translate-y-0.5 hover:bg-claire-50"
          >
            {primaryLabel}
            <ArrowRightIcon className="ml-2 h-5 w-5" aria-hidden />
          </Link>
          <Link
            to={secondaryTo}
            className="inline-flex items-center justify-center border border-white/45 bg-white/5 px-8 py-3.5 text-base font-semibold text-white backdrop-blur-sm transition hover:bg-white/15"
          >
            {secondaryLabel}
          </Link>
        </div>
      </div>
    </section>
  );
}
